import './NotFoundPage.css';

import React from 'react';

const NotFoundPage = () => {
  return (
    <div>
      <h1> Not Found 404</h1>
    </div>
  );
};

export default NotFoundPage;
